import { render } from "./Uploads.vue?vue&type=template&id=84a65e0a"
import script from "./Uploads.vue?vue&type=script&lang=js"
export * from "./Uploads.vue?vue&type=script&lang=js"
script.render = render

export default script